import { create, all } from 'mathjs'

const config = { }
const math = create(all, config)

function sumexp(x) {
    const y = [];
    const max_x = math.max(x);
    for (let i = 0; i < x.length; i++) {
        const diff = x[i] - max_x;
        if (diff < -10) y[i] = 0;
        else y[i] = math.exp(diff);
    }
    const Z = math.sum(y);
    const ret = math.multiply(y, 1 / Z);
    return ret;
}

export default class GaussClassifier {
    constructor(c_num, mu, sigma) {
        this.c_num = c_num;
        this.mu = mu;
        this.inv_sigma = [];
        this.det_sigma = [];
        for (let c = 0; c < c_num; c++) {
            this.inv_sigma[c] = math.inv(sigma[c]);
            this.det_sigma[c] = math.det(sigma[c]);
        }
    }

    predict(x) {
        const pdf = [];
        for (let c = 0; c < this.c_num; c++) {
            const diff = math.subtract(x, this.mu[c]);
            pdf[c] = -0.5 * math.multiply(diff, math.multiply(this.inv_sigma[c], diff)) - math.log(math.sqrt(this.det_sigma[c]))
        }
        const ret = sumexp(pdf);
        return ret;
    }
}